import { useState } from "react";
import { post } from "../networking/RequestService";

function useMarkCainNotificationAsRead() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const markAsRead = async (notificationId) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({ fn: "markCainNotificationAsRead", notificationId });
            return res.data;
        } catch (err) {
            setError(err.response?.data?.text || err.message);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { markAsRead, loading, error };
}

export default useMarkCainNotificationAsRead;
